import { render } from "./ModalHeader.vue?vue&type=template&id=e59e1316&scoped=true&ts=true"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"

import "./ModalHeader.vue?vue&type=style&index=0&id=e59e1316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59e1316"]])

export default __exports__